import React from "react";

import CuratorialSection from "../content/CuratorialSection";
import Layout from "../components/Layout";
import Partners from "../ui/mainPage/Partners";

const CuratorialActivities = (props) => {

    return (
        <Layout>
            <CuratorialSection />
            <Partners />
        </Layout>
    );
};

export default CuratorialActivities;
